import { apiCallStatus } from 'helpers/constants';
import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { opButtons, multiChartOptions } from './constants';

export const getActiveDetailedInformationTab = ({ detailedInformation }) => {
    return detailedInformation?.activeTab;
};

export const getActiveDetailedInformationTabV2 = ({ detailedInformation }) => {
    return detailedInformation?.activeTabV2;
};

export const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

export const getActiveTab = ({ operationalParameters }) => {
    return operationalParameters?.activeTab;
};

export const getMultiChart = ({ operationalParameters }) => {
    return operationalParameters?.multiChart;
};

const getChartData = ({ operationalParametersV2 }) => {
    return operationalParametersV2?.charts;
};

const getAssetDetails = ({ detailedInformation }) => {
    return {
        loadingStatus: detailedInformation?.assetDetails?.loadingStatus,
        details: detailedInformation?.assetDetails?.data?.details,
        errorCode: detailedInformation?.assetDetails?.error?.statusCode,
        suppressGlobalNotification: true,
    };
};

const getSensorProperties = ({ sensorProperties }) => {
    return {
        sensorProperties: sensorProperties?.sensorProperties,
        loadingStatus: sensorProperties?.sensorProperties?.loadingStatus,
        errorCode: sensorProperties?.sensorProperties?.error?.statusCode,
        suppressGlobalNotification: true,
    };
};

const getSensorGatewayInfoOP = ({ sensorProperties }) => {
    return {
        sensorProperties: sensorProperties?.sensorGatewayInfo,
        loadingStatus: sensorProperties?.sensorGatewayInfo?.loadingStatus,
        errorCode: sensorProperties?.sensorGatewayInfo?.error?.statusCode,
        suppressGlobalNotification: true,
    };
};

const getDownloadConfirmationParams = ({ downloadMeasurements }) => {
    return downloadMeasurements?.measurementDownloadDialogParams;
};
const getRawErrorData = ({ operationalParameters }) => {
    const activeTab = operationalParameters?.activeTab;
    const chartType = operationalParameters?.multiChart;

    if (operationalParameters?.trendCommentsList?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.trendCommentsList?.loadingStatus,
            error: operationalParameters?.trendCommentsList?.error,
            errorCode: operationalParameters?.trendCommentsList?.error?.statusCode,
        };
    }

    if (chartType === multiChartOptions.SINGLE && operationalParameters?.charts?.single.trend[0]?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.charts?.single.trend[0]?.loadingStatus,
            error: operationalParameters?.charts?.single.trend[0]?.error,
            errorCode: operationalParameters?.charts?.single.trend[0]?.error?.statusCode,
        };
    }

    if (chartType === multiChartOptions.MULTI && operationalParameters?.charts?.multi.trend[0]?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.charts?.multi.trend[0]?.loadingStatus,
            error: operationalParameters?.charts?.multi.trend[0]?.error,
            errorCode: operationalParameters?.charts?.multi.trend[0]?.error?.statusCode,
        };
    }

    if (activeTab === opButtons.trends && operationalParameters?.availableKPIs?.trend?.loadingStatus === apiCallStatus.ERROR) {

        return {
            loadingStatus: operationalParameters?.availableKPIs?.trend?.loadingStatus,
            error: operationalParameters?.availableKPIs?.trend?.error,
            errorCode: operationalParameters?.availableKPIs?.trend?.error?.statusCode,
        };
    }

    if (activeTab === opButtons.scatterPlotV2 && operationalParameters?.scatterV2Kpis?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.scatterV2Kpis?.loadingStatus,
            error: operationalParameters?.scatterV2Kpis?.error,
            errorCode: operationalParameters?.scatterV2Kpis?.error?.statusCode,
        };
    }

    if (activeTab === opButtons.histogramV2 && operationalParameters?.histogramV2Kpis?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.histogramV2Kpis?.loadingStatus,
            error: operationalParameters?.histogramV2Kpis?.error,
            errorCode: operationalParameters?.histogramV2Kpis?.error?.statusCode,
        };
    }

    if (activeTab === opButtons.vibrationFFTV2 && operationalParameters?.FFTV2?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters?.FFTV2?.loadingStatus,
            error: operationalParameters?.FFTV2?.error,
            errorCode: operationalParameters?.FFTV2?.error?.statusCode,
        };
    }

    return { loadingStatus: activeTab ? apiCallStatus.SUCCESS : null };
};

// Memoized selector for operational parameters error data
const getErrorData = createErrorDataSelector(getRawErrorData);

export const getModel = createSelector([
    getActiveTab,
    getAssetDetails,
    getSensorProperties,
    getMultiChart,
    getChartData,
    getSensorGatewayInfoOP,
    getDownloadConfirmationParams,
    getErrorData,
], (
    activeTab,
    assetDetails,
    sensorProperties,
    multiChart,
    chartData,
    sensorGatewayInfo,
    measurementDownloadDialogParams,
    errorData
) => {
    return {
        activeTab,
        assetDetails,
        sensorProperties,
        multiChart,
        chartData,
        sensorGatewayInfo,
        measurementDownloadDialogParams,
        errorData
    };
});
